export default "__VITE_ASSET__bbca10af__"